import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormikContext } from 'formik'
import { LayoutWithAvatar } from '../gender/gender'
import CardElement from '../../components/card.v2'
import SelectorElement from '../../components/SelectElement'
import { HoverBorderGradientDemo } from '../../components/Button'

const Method = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const navigate = useNavigate()

  const handleInputChange = (label, e) => {
    setFieldValue(`method`, label) // Update userData dynamically
  }

  const handleStartDemo = async () => {
    setCurrentStep(currentStep + 1)
    // localStorage.setItem('agent', JSON.stringify(values))
    // navigate('/demo', { state: values })
  }

  return (
    <LayoutWithAvatar>
      <div className='col-span-2 md:col-span-1 max-w-sm mx-auto flex items-center gap-20 justify-center'>
        <CardElement fixHeight className={'max-w-sm'}>
          <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
            <svg
              onClick={() => {
                setCurrentStep(currentStep - 1)
              }}
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='2'
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </h2>
          <h2 className='text-gray-700 font-semibold text-lg mb-4'>
            Meet Your Global AI Receptionist! Choose Your Prefered Method To
            Chat!
          </h2>
          <div className='flex flex-col gap-7 max-h-[170px] overflow-auto custom-scrollbar mt-6'>
            <SelectorElement
              label={'Interactive Avatar'}
              active={values.method == 'Interactive Avatar'}
              onChange={handleInputChange}
            />

            <SelectorElement
              label={'Web'}
              active={values.method == 'Web'}
              onChange={handleInputChange}
            />

            <SelectorElement
              label={'Phone'}
              active={values.method == 'Phone'}
              onChange={handleInputChange}
            />

            <SelectorElement
              label={'Chat'}
              active={values.method == 'Chat'}
              onChange={handleInputChange}
            />

            <SelectorElement
              label={'Zoom'}
              active={values.method == 'Zoom'}
              onChange={handleInputChange}
              disabled
            />
          </div>
          {/* Button */}
          <div className='mt-8'>
            <HoverBorderGradientDemo type='button' onClick={handleStartDemo}>
              <span className='font-bold capitalize'>Select</span>
            </HoverBorderGradientDemo>
          </div>
        </CardElement>
      </div>

      <div className='col-span-1 hidden md:flex items-center justify-center relative'>
        <div>
          <video
            src={`/images/webcall-${
              values.gender == 'Female' ? 'female' : 'male'
            }.webm`}
            alt='Robot'
            className='w-full'
            autoPlay
            loop
          />
        </div>
      </div>
    </LayoutWithAvatar>
  )
}

export default Method
